import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { round } from "@animech/ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./centralized-pump-component-info.style";
import { useNumberConversion } from "hooks/number-conversion";
import { selectors, useAppSelector } from "store";
import { Unit } from "utility/number";
import { systemDataConstants } from "api/system-data";
/* The pump's name and letter are in the overlay's pump section above, so the
 * results start straight away with the values. A calculation that failed is
 * not shown, but its incoming air pressure and free vacuum level are, as they
 * help tell why it failed. */
export var CentralizedPumpComponentInfo = function (_a) {
    var nodeId = _a.nodeId;
    var t = useTranslation().t;
    var convertNumber = useNumberConversion();
    var pumpPerformance = useAppSelector(selectors.selectShownOrWithheldVacuumPumpPerformance(nodeId));
    var isSystemPerformanceLoading = useAppSelector(selectors.selectIsPerformanceLoading);
    var isPerformanceDataValid = useAppSelector(selectors.selectIsPerformanceDataValid);
    var systemDataSnapshot = useAppSelector(selectors.selectPerformanceSystemDataSnapshot);
    var airConsumptionPerMinute = useMemo(function () {
        if (!pumpPerformance || !systemDataSnapshot)
            return "";
        var parameterNames = systemDataConstants.parameterNames;
        var getParameterValue = function (parameterName) { var _a; return Number((_a = systemDataSnapshot.parameters[parameterName]) === null || _a === void 0 ? void 0 : _a.value) || 0; };
        // Air per cycle × cycles per minute (the "parts per minute" target is a
        // cycle rate, whether a cycle moves one part or several boxes).
        var cyclesPerMinute = getParameterValue(parameterNames.targetPartsPerMinute) || 1;
        return convertNumber(pumpPerformance.airConsumptionTotal * cyclesPerMinute, Unit.NL_MIN).formatted;
    }, [convertNumber, pumpPerformance, systemDataSnapshot]);
    if (!pumpPerformance || isSystemPerformanceLoading)
        return null;
    var incomingAirPressure = "".concat(t("canvas.compressed_air_pressure_pump"), ": ").concat(convertNumber(pumpPerformance.compressedAirPressure, Unit.MPA).formatted);
    var freeVacuumLevel = "".concat(t("canvas.free_running_vacuum_pump"), ": ").concat(convertNumber(pumpPerformance.freeRunningVacuumLevel, Unit.KPA).formatted);
    if (!isPerformanceDataValid)
        return (_jsx(Styled.CentralizedPumpComponentInfoRoot, { children: _jsxs(Styled.Section, { children: [incomingAirPressure, _jsx("br", {}), freeVacuumLevel] }) }));
    return (_jsx(Styled.CentralizedPumpComponentInfoRoot, { children: _jsxs(Styled.Section, { children: [incomingAirPressure, _jsx("br", {}), t("canvas.time_to_part_secured", {
                    value: round(pumpPerformance.timeToPartSecured * 1000, 0),
                    context: pumpPerformance.timeToPartSecured === 0 ? "not_reached" : "",
                }), _jsx("br", {}), pumpPerformance.timeToEnergySave ? (_jsxs(_Fragment, { children: [t("canvas.time_to_energy_save", {
                            value: round(pumpPerformance.timeToEnergySave * 1000, 0),
                        }), _jsx("br", {})] })) : null, "".concat(t("canvas.final_vacuum_level"), ": ").concat(convertNumber(pumpPerformance.finalVacuumLevel, Unit.KPA).formatted), _jsx("br", {}), freeVacuumLevel, _jsx("br", {}), "".concat(t("canvas.air_consumption_pump"), ": ").concat(airConsumptionPerMinute)] }) }));
};
